import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Bed, Bath, Maximize, ChevronRight } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';

export default function UnitCard({ unit, delay = 0 }) {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay }}
    >
      <Card
        data-testid="unit-card"
        className="group rounded-xl border border-border bg-card shadow-[0_1px_0_rgba(18,20,22,0.06)] hover:shadow-[0_18px_40px_rgba(18,20,22,0.10)] transition-shadow overflow-hidden cursor-pointer"
        onClick={() => navigate(`/units/${unit.id}`)}
      >
        <div className="aspect-[16/10] overflow-hidden">
          <img
            src={unit.images[0]}
            alt={unit.unit_number}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="font-[var(--font-display)] text-xl">{unit.unit_number}</CardTitle>
            <Badge variant={unit.status === 'available' ? 'default' : 'secondary'}>
              {unit.status}
            </Badge>
          </div>
          <CardDescription className="flex items-center gap-4 text-sm">
            <span className="flex items-center gap-1">
              <Bed className="h-4 w-4" /> {unit.bedrooms} bed
            </span>
            <span className="flex items-center gap-1">
              <Bath className="h-4 w-4" /> {unit.bathrooms} bath
            </span>
            <span className="flex items-center gap-1">
              <Maximize className="h-4 w-4" /> {unit.square_feet} sqft
            </span>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-baseline justify-between mb-2">
            <div className="text-2xl font-[var(--font-display)] text-[#A06A3B]">
              ${unit.price.toLocaleString()}{unit.type === 'rental' ? '/mo' : ''}
            </div>
            {unit.type === 'rental' && (
              <Badge variant="outline" className="text-xs border-[#A06A3B] text-[#A06A3B]">
                Starting Price
              </Badge>
            )}
          </div>
          {unit.type === 'rental' && (
            <p className="text-xs text-muted-foreground mb-4">
              Furnished & unfurnished options available
            </p>
          )}
          <Button
            data-testid="unit-card-primary-cta"
            className="w-full bg-[#121416] text-[#FBF8F2] hover:bg-[#1B1F24] rounded-[var(--btn-radius)]"
          >
            View Details <ChevronRight className="ml-2 h-4 w-4" />
          </Button>
        </CardContent>
      </Card>
    </motion.div>
  );
}